import { Box, MenuItem, Stack } from '@mui/material';
import { Field, FormikProps } from 'formik';
import { TextField } from 'formik-mui';
import { UserPickerField } from 'features/user/user-picker';
import { BankAccountPicker } from 'shared/ui/formik-fields/bank-account-picker';
import { FormData } from '../prepayment.form-tools';
import { DatePickerField } from 'shared/ui/formik-fields/date-picker';
import { PayOrderStatus, POS_STATUSES } from '@sr/dto';
import { SalaryPeriodField } from 'entities/salary/salary-period/salary-period.field';
import { useEffect } from 'react';
import { formatDateMonthYear } from 'utils/date-format-helpers';
import { useUser } from 'entities/user/profile/lib';
import { formatPersonFull } from 'utils/person-format-helpers';

export const PrepaymentFormFields = (props: FormikProps<FormData> & { isNew: boolean }) => {

  const { isNew, values, setFieldValue } = props;
    
  const { user } = useUser(Number(values.userId) || 0);

  useEffect(() => {
    const generateDescription = () => {
      const { userId, period } = values;  
      if (userId && period && user) {
        const description = `Аванс ${formatPersonFull(user)} за период "${formatDateMonthYear(period.year, period.month)}"`;
        setFieldValue('description', description);   
      } 
    };
    generateDescription();
  }, [values.userId, values.period, user, setFieldValue]);

  return (
    <Box minWidth={400} pb={1}>
      <Stack spacing={2}>
        <Field
          required
          name="period"
          component={SalaryPeriodField}
        />
        <Field
          required
          name="paymentDate"
          component={DatePickerField}
          fullWidth
          label="Дата ПП"
        />
        <Field
          fullWidth
          required
          name="userId"
          label="Сотрудник"
          component={UserPickerField}
        />
        <Field
          name="description"
          component={TextField}
          fullWidth
          required
          label="Назначение платежа"
          style={{ display: 'none' }}
          InputProps={{ style: { display: 'none' } }}
          InputLabelProps={{ style: { display: 'none' } }}
        />
        <Field
          name='status'
          component={TextField}
          select
          fullWidth
          label='Статус'
          disabled={isNew}
        >
          {Object.keys(POS_STATUSES).map(key =>
            <MenuItem key={key} value={key}>
              {POS_STATUSES[Number(key) as PayOrderStatus]}
            </MenuItem>)}
        </Field>
        <Field
          required
          name="accountId"
          component={BankAccountPicker}
          label="Расчетный счет"
          fullWidth
        />
        <Field
          fullWidth
          required
          name="sum"
          label="Сумма внесения"
          type="number"
          component={TextField}
        />
      </Stack>
    </Box>
  );
};
